import { apiClient } from "./client";

const postScore = (id, session) => {
    return apiClient.post(`/intervention-plans/${id}/sessions`, session);
}
export default postScore;
